var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !!_vm.plane && !!_vm.plane.flightInfos
    ? _c(
        "md-card",
        { staticClass: "plane-info-flight" },
        [
          _c("md-card-header", [
            _c("div", { staticClass: "md-title" }, [
              _vm._v("\n            " + _vm._s(_vm.plane.name) + "\n        ")
            ]),
            _vm._v(
              "\n        " +
                _vm._s(_vm.$t("registration.slogan-pro-pilot")) +
                "\n    "
            )
          ]),
          _vm._v(" "),
          _c("md-card-content", [
            _c("span", [
              _c("img", { attrs: { src: "/imgs/icons/clock.svg" } }),
              _vm._v(" "),
              _c("p", {
                domProps: {
                  innerHTML: _vm._s(
                    _vm.$t("registration.flight-time-alt", {
                      flightTimeHours: _vm.plane.flightInfos.flightTimeHours,
                      flightTimeMinutes: _vm.plane.flightInfos.flightTimeMinutes
                    })
                  )
                }
              })
            ]),
            _vm._v(" "),
            _c("span", [
              _c("img", { attrs: { src: "/imgs/icons/clock.svg" } }),
              _vm._v(
                " " + _vm._s(_vm.$t("registration.estimation")) + "\n        "
              )
            ]),
            _vm._v(" "),
            _c("div", {
              staticClass: "price",
              domProps: {
                innerHTML: _vm._s(_vm.plane.flightInfos.priceLabelAlt)
              }
            }),
            _vm._v(" "),
            _c("div", { staticClass: "mention" }, [
              _vm._v(
                "\n            " +
                  _vm._s(_vm.$t("registration.mention")) +
                  "\n        "
              )
            ])
          ])
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true
module.exports = { render: render, staticRenderFns: staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-0be02379", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0be02379","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/plane-info-flight.vue
// module id = ./node_modules/vue-loader/lib/template-compiler/index.js?{"id":"data-v-0be02379","hasScoped":false,"buble":{"objectAssign":"Object.assign","transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/assets/js/components/registration/Profile/plane-info-flight.vue
// module chunks = 1 2 3